var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStats = function SvgStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#C3D3E5",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M7.553 3.522C7.553 3.234 7.305 3 7 3s-.553.234-.553.522v6.956c0 .288.248.522.553.522s.553-.234.553-.522zM10.5 6.304c0-.288-.247-.521-.553-.521-.305 0-.552.233-.552.521v4.174c0 .288.247.522.552.522s.553-.234.553-.522zM4.605 7.696c0-.288-.247-.522-.552-.522s-.553.233-.553.522v2.782c0 .288.247.522.553.522.305 0 .552-.234.552-.522z",
    clipRule: "evenodd"
  })));
};
export { SvgStats as ReactComponent };